import cs from 'classnames';
import Image from 'next/image';
import type { FC } from 'react';
import type { IBaseComponentProps } from '@/Module/Core/Model/DataModel';
import { CERTIFICATES } from '@/Module/DefaultLayout/Constant';
const CertificateList: FC<IBaseComponentProps> = ({
  className
}) => {
  return <ul className={cs(className, 'flex flex-row flex-wrap items-center justify-center gap-4 w-64 md:w-auto mx-auto')} data-sentry-component="CertificateList" data-sentry-source-file="CertificateList.tsx">
      {CERTIFICATES.map(cert => <li key={cert.id} className={`duration-500 hover:translate-y-1 hover:cursor-pointer ${cert.className}`}>
          {cert.href ? <a target="_blank" referrerPolicy={cert.referrerPolicy || 'origin'} rel={cert.referrerPolicy === 'origin' ? 'noopener' : 'noopener noreferrer'} href={cert.href}>
              <Image width={cert.width} height={cert.height} alt={cert.alt} src={cert.src} referrerPolicy={cert.referrerPolicy || 'origin'} />
            </a> : <Image width={cert.width} height={cert.height} id={cert.id} alt={cert.alt} src={cert.src} referrerPolicy={cert.referrerPolicy || 'origin'} onClick={cert.onClick} />}
        </li>)}
    </ul>;
};
export default CertificateList;